import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, CanLoad, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import { CONSTANTS_DATA } from '@fitness-force/constants';
import { Store } from '@ngrx/store';
import { AuthSevices } from 'libs/api/src/lib/auth.service';
import { Observable, of, switchMap } from 'rxjs';


@Injectable({
    providedIn: 'root'
})
export class NoAuthGuard implements CanActivate, CanActivateChild
{
    /**
     * Constructor
     */
    constructor(
        private _authService: AuthSevices,
        private _router: Router,
        private store: Store
    )
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Can activate
     *
     * @param route
     * @param state
     */
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean
    {
            // Check the authentication status
            return this._check(state);
    }

    /**
     * Can activate child
     *
     * @param childRoute
     * @param state
     */
    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree
    {
         // Check the authentication status
         return this._check(state);
    }


     /**
     * Check the authenticated status
     *
     * @private
     */
     private _check(state: RouterStateSnapshot): Observable<boolean>
     {
      if(this._authService.isLoginedIn){
        // let returnUrl=  state.url.includes('?')?state.url.split('?')[0]:state.url
        //  this._router.navigate([returnUrl?returnUrl:CONSTANTS_DATA.DEFAULT.LOGIN_SUCCESS_REDIRECTION] );
         this._router.navigateByUrl(CONSTANTS_DATA.DEFAULT.LOGIN_SUCCESS_REDIRECTION);
        return  of(false)
       }else{
         return of(true)
     }
    }

}
